import { getChartLibrarySession } from "./chart-library";

export class AdminRequestError extends Error {
  constructor(
    message: string,
    public status: number,
  ) {
    super(message);
  }
}

export async function adminRequest<T>(resource: string, options: RequestInit = {}) {
  const session = getChartLibrarySession();
  if (!session) throw new AdminRequestError("Sign in to access administration.", 401);
  const [resourceName, queryString] = resource.split("?", 2);
  const headers = new Headers(options.headers);
  if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  if (!headers.has("Authorization")) headers.set("Authorization", `Bearer ${session.token}`);
  const response = await fetch(
    `/api/admin?resource=${encodeURIComponent(resourceName)}${queryString ? `&${queryString}` : ""}`,
    {
      ...options,
      headers,
    },
  );
  const data = (await response.json().catch(() => ({}))) as T & { error?: string };
  if (!response.ok)
    throw new AdminRequestError(data.error || "Admin request failed.", response.status);
  return data;
}

export function adminMutation<T>(body: Record<string, unknown>) {
  return adminRequest<T>("mutation", { method: "POST", body: JSON.stringify(body) });
}

export async function getAdminAccess() {
  try {
    const result = await adminRequest<{ isAdmin: boolean }>("access");
    return result.isAdmin;
  } catch (error) {
    if (error instanceof AdminRequestError && [401, 403].includes(error.status)) return false;
    return false;
  }
}
